import { LocalLocationContainerLight } from '../../local-loads/shared/local-location-container-light.model';
import { Moment } from 'moment';
import * as moment from 'moment';

export class Asset {

  public id: string;
  public location: LocalLocationContainerLight;
  public userId: string;
  public userEmail: string;
  public userRole: string;
  public reportedAt: Moment;
  public productCode: string;
  public productDescription: string;
  public quantity: number;
  public carrierName: string;
  public deliveryNumbers: string;
  public vehicle: string;

  static fromDto(a: any): Asset {
    if (!a) {
      return null;
    }

    const asset = new Asset();

    asset.id                 = a.id;
    asset.location           = LocalLocationContainerLight.fromDto(a.location);
    asset.userId             = a.user_id;
    asset.userEmail          = a.user_email;
    asset.reportedAt         = moment(a.reported_at);
    asset.productCode        = a.product_code;
    asset.productDescription = a.product_description;
    asset.quantity           = a.quantity;
    asset.carrierName        = a.carrier_name;
    asset.deliveryNumbers    = a.delivery_numbers;
    asset.vehicle            = a.vehicle ? a.vehicle : '/';
    asset.userRole           = a.user_role;

    return asset
  }
}
